import { render, staticRenderFns } from "./LojasEdicao.vue?vue&type=template&id=54559772&"
import script from "./LojasEdicao.vue?vue&type=script&lang=ts&"
export * from "./LojasEdicao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports